// TODO this file will manage timegating ordering for Curbside Pickup
import * as dayjs from 'dayjs';
import localized from 'dayjs/plugin/localizedFormat';
import isBetween from 'dayjs/plugin/isBetween';

dayjs.extend(localized);
dayjs.extend(isBetween);

export const checkIfOpen = (curbsideHours) => {
  const todaysHours = curbsideHours[dayjs().format('dddd').toLowerCase()];
  const currentTime = dayjs();

  try {
    const openingTime = dayjs()
      .hour(parseInt(todaysHours.openTime.split(':')[0]))
      .minute(0);
    const closingTime = dayjs()
      .hour(parseInt(todaysHours.closeTime.split(':')[0]))
      .minute(0);

    window.dispatchEvent(
      new CustomEvent('store-status', {
        detail: {
          isStoreOpen: currentTime.isBetween(openingTime, closingTime),
        },
      })
    );
  } catch (err) {
    console.log('something went wrong while checking if the store was open');
    console.log(err);
    window.dispatchEvent(
      new CustomEvent('store-status', {
        detail: {
          isStoreOpen: false,
        },
      })
    );
  }

  setTimeout(() => {
    checkIfOpen(curbsideHours);
  }, 1000 * 60);
};
